module.exports = __webpack_public_path__ + "static/media/211231_GKC_Cam_04.471074b3.webp";